module.exports = __webpack_public_path__ + "static/media/1009399.bb1b8da9.png";